import React from 'react';
import { SignOutButton } from 'modules/auth';
import IMAGES from 'modules/assets/web';

import NavItems from '../nav/NavItems';

class SideNavigation extends React.Component {
  render() {
    return (
      <nav className="sidebar d-none d-md-block col-md-3">
        <div className="sidebar-header bg-dark p-4 d-flex justify-content-center">
          <img
            alt="app-logo"
            className="sidebar-app-logo"
            src={IMAGES.LOGO_RED}
          />
        </div>
        <div className="sidebar-sticky d-flex flex-column">
          <div className="bg-dark">
            <img
              alt="city-scape"
              className="img-fluid"
              src={IMAGES.SIDEBAR_CITYSCAPE}
            />
          </div>
          <ul className="nav flex-column position-relative">
            <NavItems />
            <li className="nav-item position-absolute signout">
              <SignOutButton />
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default SideNavigation;
